





























import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import EditIcon from "@/basics/icon/EditIcon.vue";
import SimpleTable from "@/basics/table/SimpleTable.vue";
import EditModal from "@/components/modal/EditModal.vue";
import DeleteModal from "@/components/modal/DeleteModal.vue";
import {
  OneAppUserData,
  ONE_APP_USER,
  OneAppUserVariables
} from "@/graphql/query/appUser/one";
import formatDate from "@/lib/formatDate";
import EditableText, { SaveEventHandler } from "@/containers/EditableText.vue";
import { updateAppUser } from "@/graphql/mutation/updateAppUser";
import { deleteAppUser } from "@/graphql/mutation/deleteAppUser";

export interface AppUser {
  id: string;
  name: string;
  buildings: {
    id: string;
    name: string;
    rooms: {
      id: string;
      name: string;
    }[];
  }[];
  start: number;
  end: number;
  expired: boolean;
  prePeriod: boolean;
}

@Component({
  components: {
    CButton,
    SimpleTable,
    EditModal,
    DeleteModal,
    EditIcon,
    EditableText
  },
  apollo: {
    appUser: {
      query: ONE_APP_USER,
      variables(): OneAppUserVariables {
        return { id: this.$apollo.vm.$route.params.appUserId };
      },
      update(data: OneAppUserData): AppUser {
        return data.appUser;
      }
    }
  }
})
export default class AppAccountDetails extends Vue {
  appUser: AppUser | null = null;
  showDeleteModal: boolean = false;

  get start(): string {
    return formatDate(new Date(this.appUser!.start!));
  }

  get end(): string {
    return formatDate(new Date(this.appUser!.end));
  }

  async saveName(handler: SaveEventHandler) {
    handler(async (value: string) => {
      // 保存
      await updateAppUser(this.$apollo, {
        appUserId: this.appUser!.id,
        name: value
      });

      // クエリ再取得
      await this.$apollo.queries.appUser.refresh();
    });
  }

  async deleteAppAccount() {
    try {
      await deleteAppUser(this.$apollo, this.appUser!.id);
      this.$router.push({ name: "app-accounts-list" });
    } catch {
      alert("削除に失敗しました");
      this.showDeleteModal = false;
    }
  }
}
